export default "__VITE_ASSET__B2T6qNdV__"